/* GSAP plugin registration and ScrollSmoother setup, previously inline in
   layout/theme.liquid. Loaded with `defer` straight after vendor-libs.js.
   `mm` and `mainScroller` stay top-level globals: layered-images.liquid reads `mm`,
   and scrollPageTo / freezeScroll / unfreezeScroll in theme.liquid read `mainScroller`. */
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);
let mm = gsap.matchMedia();
var mainScroller = null;
const inEditor = document.querySelector('[data-shopify-editor-section]');
if (!inEditor) {
  mm.add('(pointer:fine)', () => {
    mainScroller = ScrollSmoother.create({
      smooth: 1.9,
      effects: true,
      smoothTouch: .0001,
      normalizeScroll: {
        allowNestedScroll: true,
      },
      ignoreMobileResize: true
    });
  })
}
